module.exports = new __parcel__URL__("blogPostIcon.e3cb4562.svg").toString();